import React, { useState } from "react";

const videoId = "3oHrvkIKeKY";

const chapters = [
  { time: "00:00", seconds: 0, title: "Introduction" },
  { time: "00:55", seconds: 55, title: "LostDC SMP Features" },
  { time: "01:10", seconds: 70, title: "LostDC Store and DC Coin Introduction" },
  { time: "01:49", seconds: 109, title: "What is DC Coin?" },
  { time: "02:28", seconds: 148, title: "How to Earn DC Coins" },
  { time: "03:28", seconds: 208, title: "About Server Sync" },
  { time: "04:29", seconds: 269, title: "LostDC Account Verification" },
  { time: "05:23", seconds: 323, title: "Discord Verification" },
  { time: "06:13", seconds: 373, title: "Minecraft Verification" },
  { time: "07:51", seconds: 471, title: "DC Coin Wallet and Transaction History" },
  { time: "08:25", seconds: 505, title: "How to Purchase Items from LostDC Store" },
  { time: "08:56", seconds: 536, title: "How to Claim Items in Minecraft" },
  { time: "09:24", seconds: 564, title: "How to Contact Support / Create a Ticket" },
  { time: "10:02", seconds: 602, title: "Outro" },
];

export default function HowToVerify() {
  const [startAt, setStartAt] = useState(0);
  const [activeChapter, setActiveChapter] = useState(0);

  const jumpToChapter = (chapter, index) => {
    setStartAt(chapter.seconds);
    setActiveChapter(index);
  };

  return (
    <main className="how-to-verify-page">
      <div className="how-to-verify-container">
        <header className="verify-heading">
          <span className="verify-eyebrow">LOSTDC • VIDEO GUIDE</span>
          <h1>How to Verify</h1>
          <p>
            Your complete guide to LostDC, DC Coins, account verification,
            and using the LostDC Store.
          </p>
        </header>

        <section className="verify-video-layout">
          <aside className="verify-ad-column" aria-label="Advertisement spaces">
            <div className="verify-ad-slot">Advertisement</div>
            <div className="verify-ad-slot">Advertisement</div>
          </aside>

          <div className="verify-video-section">
            <div className="verify-video-player">
              <iframe
                key={startAt}
                src={`https://www.youtube.com/embed/${videoId}?start=${startAt}&autoplay=1&origin=https://store.lostdrkc.in`}
                title="How to Verify Your LostDC Account"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <div className="verify-video-caption">
              <span>NOW PLAYING</span>
              <strong>{chapters[activeChapter].title}</strong>
              <a
                href={`https://www.youtube.com/watch?v=${videoId}&t=${startAt}s`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open on YouTube ↗
              </a>
            </div>
          </div>

          <aside className="verify-ad-column" aria-label="Advertisement spaces">
            <div className="verify-ad-slot">Advertisement</div>
            <div className="verify-ad-slot">Advertisement</div>
          </aside>
        </section>

        <section className="verify-chapters">
          <div className="verify-chapters-heading">
            <div>
              <h2>Video Chapters</h2>
              <p>Choose a topic to jump straight to that part of the video.</p>
            </div>
            <span className="verify-chapter-count">
              {chapters.length} CHAPTERS
            </span>
          </div>

          <div className="verify-chapter-list">
            {chapters.map((chapter, index) => (
              <button
                key={chapter.seconds}
                type="button"
                className={`verify-chapter ${
                  activeChapter === index ? "active" : ""
                }`}
                onClick={() => jumpToChapter(chapter, index)}
              >
                <span className="verify-chapter-play">
                  {activeChapter === index ? "▶" : "▷"}
                </span>
                <span className="verify-chapter-time">{chapter.time}</span>
                <span className="verify-chapter-title">{chapter.title}</span>
                <span className="verify-chapter-arrow">↗</span>
              </button>
            ))}
          </div>
        </section>

      </div>

      <style>{`
        .how-to-verify-page {
          box-sizing: border-box;
          width: 100%;
          min-height: 70vh;
          padding: 110px 22px 64px;
        }

        .how-to-verify-container {
          width: 100%;
          max-width: 1000px;
          margin: 0 auto;
        }

        .verify-heading {
          text-align: center;
          margin-bottom: 34px;
        }

        .verify-eyebrow {
          display: inline-block;
          margin-bottom: 12px;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 2px;
          opacity: 0.65;
        }

        .verify-heading h1 {
          margin: 0 0 14px;
          font-size: clamp(32px, 5vw, 46px);
          line-height: 1.15;
          font-weight: 850;
        }

        .verify-heading p {
          max-width: 660px;
          margin: 0 auto;
          font-size: 15px;
          line-height: 1.8;
          opacity: 0.72;
        }

        .verify-video-layout {
          display: grid;
          grid-template-columns: minmax(125px, 160px) minmax(0, 1fr) minmax(125px, 160px);
          align-items: start;
          gap: 16px;
        }

        .verify-ad-column {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .verify-ad-slot {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 230px;
          padding: 12px;
          box-sizing: border-box;
          border: 1px dashed var(--border, rgba(128,128,128,0.35));
          border-radius: 12px;
          background: var(--card, rgba(128,128,128,0.035));
          color: inherit;
          font-size: 11px;
          letter-spacing: 0.5px;
          opacity: 0.65;
          text-align: center;
        }

        .verify-video-section {
          min-width: 0;
          overflow: hidden;
          border: 1px solid var(--border, rgba(128,128,128,0.22));
          border-radius: 18px;
          background: var(--card, rgba(128,128,128,0.04));
        }

        .verify-video-player {
          position: relative;
          width: 100%;
          aspect-ratio: 16 / 9;
          background: #090909;
        }

        .verify-video-player iframe {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }

        .verify-video-caption {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 10px 14px;
          padding: 15px 19px;
        }

        .verify-video-caption > span {
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 1px;
          opacity: 0.6;
        }

        .verify-video-caption strong {
          flex: 1;
          min-width: 160px;
          font-size: 14px;
        }

        .verify-video-caption a,
        .verify-help a {
          color: var(--primary, #8b7cff);
          font-size: 13px;
          font-weight: 700;
          text-decoration: none;
        }

        .verify-chapters {
          margin-top: 30px;
          padding: 24px;
          border: 1px solid var(--border, rgba(128,128,128,0.22));
          border-radius: 18px;
          background: var(--card, rgba(128,128,128,0.035));
        }

        .verify-chapters-heading {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          margin-bottom: 20px;
        }

        .verify-chapters-heading h2 {
          margin: 0 0 7px;
          font-size: 23px;
          font-weight: 800;
        }

        .verify-chapters-heading p {
          margin: 0;
          font-size: 13px;
          line-height: 1.6;
          opacity: 0.7;
        }

        .verify-chapter-count {
          flex-shrink: 0;
          padding: 7px 10px;
          border-radius: 8px;
          background: rgba(128,128,128,0.12);
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.5px;
        }

        .verify-chapter-list {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 9px;
        }

        .verify-chapter {
          display: flex;
          align-items: center;
          gap: 11px;
          min-width: 0;
          padding: 13px 12px;
          border: 1px solid var(--border, rgba(128,128,128,0.18));
          border-radius: 11px;
          background: transparent;
          color: inherit;
          text-align: left;
          font: inherit;
          cursor: pointer;
          transition: background 0.18s ease, border-color 0.18s ease;
        }

        .verify-chapter:hover {
          background: rgba(128,128,128,0.09);
        }

        .verify-chapter.active {
          border-color: var(--primary, #8b7cff);
          background: rgba(139,124,255,0.10);
        }

        .verify-chapter-play {
          flex-shrink: 0;
          width: 20px;
          font-size: 16px;
          text-align: center;
          opacity: 0.8;
        }

        .verify-chapter-time {
          flex-shrink: 0;
          font-size: 12px;
          font-variant-numeric: tabular-nums;
          font-weight: 800;
          opacity: 0.65;
        }

        .verify-chapter-title {
          flex: 1;
          min-width: 0;
          font-size: 12px;
          line-height: 1.5;
          font-weight: 650;
        }

        .verify-chapter-arrow {
          flex-shrink: 0;
          opacity: 0.4;
          font-size: 13px;
        }

        @media (max-width: 650px) {
          .how-to-verify-page {
            padding: 52px 13px 40px;
          }

          .verify-video-layout {
            grid-template-columns: minmax(0, 1fr);
          }

          .verify-ad-column {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          .verify-ad-slot {
            min-height: 100px;
          }

          .verify-video-layout > .verify-ad-column:first-child {
            order: 2;
          }

          .verify-video-layout > .verify-video-section {
            order: 1;
          }

          .verify-video-layout > .verify-ad-column:last-child {
            order: 3;
          }

          .verify-heading {
            margin-bottom: 24px;
          }

          .verify-heading p {
            font-size: 14px;
          }

          .verify-video-section,
          .verify-chapters {
            border-radius: 13px;
          }

          .verify-chapters {
            padding: 15px 12px;
            margin-top: 20px;
          }

          .verify-chapters-heading {
            align-items: flex-start;
          }

          .verify-chapters-heading h2 {
            font-size: 20px;
          }

          .verify-chapter-count {
            font-size: 9px;
          }

          .verify-chapter-list {
            grid-template-columns: 1fr;
            gap: 7px;
          }

          .verify-chapter {
            padding: 12px 10px;
          }

          .verify-video-caption {
            padding: 12px;
          }
        }
      `}</style>
    </main>
  );
}
